import { Injectable } from '@angular/core'

import { Subject } from 'rxjs/Subject'
import { Subscription } from 'rxjs/Subscription'
import { Observable } from 'rxjs/Observable'

@Injectable()
export class EventsEmitterService {
  private subject: Subject<any>

  constructor () {
    this.subject = new Subject<Object>()
  }

  emit (label: string, data) {
    this.subject.next({label, data})
  }

  subscribe (label: string, fn): Subscription {
    return this.subject.asObservable()
      .filter((ev) => label === ev.label || label === 'all')
      .subscribe((event) => fn(event.label, event.data))
  }

  listen (label: string): Observable<Object> {
    return this.subject.asObservable()
      .filter(ev => ev.label === label || label === 'all')
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/services/events-emitter.service.ts